enum Events {
  // General
  registered = 'Signed Up',
  store_connected = 'Store Connected',
  store_disconnected = 'Store Disconnected',
  address_created = 'Address Created',
  credit_card_added = 'Credit Card Added',
  // registered_carrier = 'Registered Carrier',
  carrier_connected = 'Carrier Connected',
  carrier_error_displayed = 'Carrier Error Displayed',
  package_template_created = 'Package Template Created',
  // Label Purchases
  label_purchase = 'Label Purchased',
  label_purchase_failed = 'Label Purchase Failed',
  // viewed_rates = 'Viewed Rates',
  label_downloaded = 'Label Downloaded',
  packing_slip_downloaded = 'Packing Slip Downloaded',
  tracking_status_viewed = 'Tracking Status Viewed',
  // New User Onboarding
  onboarding_step_completed = 'Step Completed',
  onboarding_completed = 'Onboarding Completed',
  // Get Started
  get_started_viewed = 'Get Started Page View',
  // Insurance
  insurance_updated = 'Insurance Updated',
  insurance_modal_opened = 'Insurance Modal Opened',
  insurance_modal_link_clicked = 'Insurance Modal Link Clicked',
  // Tracking Settings
  email_notification_changed = 'Email Notifications Changed',
  // Onboarding
  insurance_option_onboarding = 'Insurance option during onboarding',
  // Insurance Settings
  automatic_insurance_settings_update = 'Automatic insurance settings update',
  insurance_removal = 'Insurance removal in confirmation modal',
  insurance_removal_order_details = 'Remove Insurance from Order Details',
  // Signature Settings
  signaure_modal_opened = 'Signature Confirmation Modal Opened',
  signature_modal_updated = 'Signature Confirmation Modal Updated',
  signature_removal_order_details = 'Remove Signature from Order Details',
  // UPS Surcharge warning
  ups_surcharge_warning = 'UPS surcharge warnings',
  // Cost Clarity Insurance
  insurance_details_opened = 'Insurance Details Opened From Sidebar',
  signature_details_opened = 'Signature Details Opened From Sidebar',
  signature_updated = 'Signature Details Updated From Sidebar',
  new_insurance_updated = 'Insurance Updated From Sidebar',
  insurance_link_clicked = 'Insurance Link Clicked From Sidebar',
  insurance_removed_sidebar = 'Remove Insurance From Sidebar',
  signature_removed_sidebar = 'Remove Signature From Sidebar',
  // Billing settings
  promo_code_add_replace = 'Promo code added or replaced',
  // Package settings
  save_default_package_units = 'Default package units updated',
  // Profile settings
  update_user_information = 'User profile updated',
  update_user_language = 'User language updated',

  // Order search
  order_search_completed = 'Order search completed',
  order_search_result_selected = 'Order search row selected',

  // Customs
  customs_options_form_submit = 'Customs Options Form Submit',
  customs_items_form_submit = 'Customs Items Form Submit',

  // Package info edited
  package_info_edited = 'Package Info Updated',

  // Sign-up/Login from Wix
  embeddable_next_params = 'Embeddable User Set Next Params',

  // Pro plan related events
  plan_updated = 'Plan Updated',
}

export const EVENT_ORIGIN_SIDEPANEL = 'Side panel';
export const EVENT_ORIGIN_ORDER_DETAILS = 'Order details';
export const EVENT_ORIGIN_BATCH_EDIT = 'Batch edit';
export const EVENT_ORIGIN_LEGACY_ORDER = 'Legacy orders table';

export interface Traits {
  id?: number;
  login_user_id?: number;
  username?: string;
  first_name?: string;
  last_name?: string;
  email?: string;
  revenue_tier_name?: string;
  blocked_billing?: boolean;
  fraud_status?: string;
  payment_type?: string;
  current_promo_code?: string;
  current_promo_start_date?: string;
  current_promo_end_date?: string;
  date_joined?: string;
  lifetime_vol_segment_min?: number;
  lifetime_vol_segment_max?: number;
  is_idv_required?: boolean;
  sender_address_company?: string;
  sender_address_city?: string;
  sender_address_state?: string;
  sender_address_country_name?: string;
  sender_address_name?: string;
  sender_address_phone?: string;
  sender_address_email?: string;
  master_account_available?: boolean;
  personal_carriers?: string[];
  preferred_carrier?: string;
  orders_count?: number;
  is_account_owner?: boolean;
}

export default Events;
